// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legend_legend__tqn1r","name":"Legend_name__3sFPs"};